<template>
  <div class="clearfix heading-wrapper">
    <div class="col col-12 heading-image">
    </div>
  </div>
</template>

<script>

export default {
  name: 'app-heading-image'
}
</script>

<style scoped lang="scss">
@import "../assets/scss/variables";

.heading-image {
  height: 75vh;
  background-color: lightgrey;
  background-image: url('../assets/header/harald-parainer-header.png');
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: cover;

  @media screen and (max-width: $break-md) {
    background-position: center center;
    background-size: 400px;
    height: 300px;
    background-image: url('../assets/header/harald-parainer-small.jpg');
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeadingImage.vue